import { render, staticRenderFns } from "./SystemNotice.vue?vue&type=template&id=262e3aec&"
import script from "./SystemNotice.vue?vue&type=script&lang=js&"
export * from "./SystemNotice.vue?vue&type=script&lang=js&"
import style0 from "./SystemNotice.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports